<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-eye-invisible`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.536 3.707l38.183 38.184a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0L3.707 6.535a1 1 0 010-1.414l1.414-1.414a1 1 0 011.415 0zm1.46 11.357l2.614 2.614C9.027 19.42 7.49 21.514 6 23.974 11.521 32.883 17.496 37 23.97 37a14.86 14.86 0 005.07-.888l3.008 3.006C29.477 40.373 26.785 41 23.968 41 15.497 41 8.175 35.334 2 24.004c1.871-3.53 3.87-6.51 5.995-8.94zM23.966 7C32.603 7 39.947 12.668 46 24.004c-1.916 3.49-3.939 6.443-6.068 8.859l-2.615-2.616c1.594-1.739 3.155-3.825 4.683-6.273C36.584 15.099 30.602 11 23.97 11c-1.73 0-3.412.278-5.051.848l-3.021-3.02A18.482 18.482 0 0123.968 7zm-7.919 16.119l8.833 8.833a8 8 0 01-8.833-8.833zM24 16a8 8 0 017.952 8.881l-8.833-8.833c.29-.032.583-.048.881-.048z"/></svg>
</template>
<script>

export default {
  name: 'IconEyeInvisible',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
